import styled, { css } from 'styled-components';
import SVG from '../../../../../SVG';

export const SelectedItemMaskContainer = styled.div<{
  pinned?: boolean;
  hover?: boolean;
}>`
  ${({ pinned = false }) => css`
    width: calc(100% - 10px);
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: ${pinned ? '#5133892e' : 'transparent'};
    padding: 5px;
  `}
`;

export const SelectedItemMaskLabel = styled.div`
  cursor: pointer;
`;

export const SelectedItemMaskControlContainer = styled.div``;

export const SelectedItemMaskControl = styled.button<{
  pinned?: boolean;
  hover?: boolean;
  emptyList?: boolean;
}>`
  ${({ pinned = false, hover = false, emptyList = false }) => css`
    visibility: ${pinned || hover || emptyList ? 'visible' : 'hidden'};
    border: none;
    background: transparent;
    border-radius: 5px;
    &:hover {
      background: #ffffffd3;
    }
    &:active {
      background: #ffffffb0;
    }
  `}
`;

export const SelectedItemMaskControlIcon = styled(SVG.Icon.Pin)<{
  pinned?: boolean;
  hover?: boolean;
}>`
  ${({ pinned = false }) => css`
    width: 20px;
    height: 20px;
    fill: ${pinned ? '#513389' : '#bdbdbd'};
  `}
`;
